/**
 * Created by Jerker Nord on 2023-10-13.
 */
import {LonerGameAssets} from "../../../../LonerGameAssets";
import {Loner} from "../../../../Loner";

export class LonerStartContainer extends PIXI.Container {

    private static LONER_HOUSE_POSITION: PIXI.Point = new PIXI.Point(90, 275);

    private _lonerHouse: PIXI.Sprite;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this._lonerHouse = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TTB_LONER_HOUSE_PIXELS)[0]);
        this._lonerHouse.anchor.set(0.5, 0.5);
        this._lonerHouse.scale.set(2.5, 2.5);
        this._lonerHouse.position = LonerStartContainer.LONER_HOUSE_POSITION;
        this.addChild(this._lonerHouse);
    }
}